<template>
  <v-dialog v-model="dialog" persistent max-width="300">
    <v-card v-if="device.data">
      <v-card-title class="headline">تغیر وضعیت</v-card-title>
      <v-card-text>
        آیا از تغییر وضعیت
        {{ device.name }}
        به
        {{ !device.set._value ? 'غیر فعال' : 'فعال' }}
        مطمئنید؟
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="$emit('cancel')">انصراف</v-btn>
        <v-spacer></v-spacer>
        <v-btn
            :color="!device.set._value ? 'success' : 'red'"
            :loading="loading"
            @click="$emit('confirm')"
        >
          تایید
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "StatusConfirmationDialog",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    device: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
